var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"block":"","color":"default","to":{ name: 'AuthHome' }}},[_c('v-icon',{attrs:{"small":""}},[_vm._v(_vm._s(_vm.mdiArrowLeft))]),_vm._v(" "+_vm._s(_vm.$t('common.back'))+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }